// extracted by mini-css-extract-plugin
export default {"container":"Congratsticket_container__igR4p","paybtn":"Congratsticket_paybtn__SCBqD"};